<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Submission Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${submission.publicNumber()}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['add submission']">
      <template #gated-content>
        <SubmissionForm :submission="submission" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import { notificationOptions } from "@/shared/toast-notification-options";
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import SubmissionForm from '@/components/lab/submission/SubmissionForm'
import { LabRepositoryFactory } from '@/repositories/lab/LabRepositoryFactory'
import { submissionNotifications } from "@/shared/notifications";

const SubmissionRepository = LabRepositoryFactory.get("submission");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: 'SubmissionEdit',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SubmissionForm
  },
  data () {
    return {
      loading: true,
      submission_id: this.$route.params.submission_id || null,
      submission: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/submissions/${this.submission_id}`,
            title: "View sample",
            variant: "info",
          },
        ]
      }
    },
  },
  async mounted () {
    this.loading = true

    this.submission = await getModel({
      model_type: 'submission',
      id: this.submission_id,
      message: this.$bvToast
    })

    this.loading = false
  },
  methods: {
    async submit (form_data) {
      try {
        await SubmissionRepository.update(this.submission_id, form_data)
        
        this.editSuccess()
        this.$router.push(`/submissions/${this.submission_id}`)
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        })
      }
    }
  },
  notifications: submissionNotifications,
}
</script>
